import type { ExportFormat } from './types';
import { basicPdfFormat } from './formats/basicPdf';
import { dashboardVisualPdfFormat } from './formats/dashboardVisualPdf';

// Source of truth for which export options the project page offers. The
// dropdown menu maps over this list — add a new format by writing it as
// `formats/<id>.ts` and registering it here. Order is preserved in the
// menu, so put the most-used option first.
export const EXPORT_FORMATS: ExportFormat[] = [
  basicPdfFormat,
  dashboardVisualPdfFormat,
];
